import { useSelector } from "react-redux";
import Header from "./Header";
import "./style.css";
import AboutUs from "./AboutUs";
import Leadership from "./Leadership";
import Static from "./Static";
import Footer from "../Footer";
import { useEffect, useState } from "react";
import LoadingPageService from "../../services/LoadingPageService";
import Clients from "./Clients";

const LandingPage = () => {
	const lang = useSelector((state) => state?.lang?.lang);
	const [data, setData] = useState({
		header: [],
		about_us: [],
		clients: [],
	});
	const loadingPageService = new LoadingPageService();

	useEffect(() => {
		let information = {};
		Promise.all([
			loadingPageService.getList("banner"),
			loadingPageService.getList("client"),
			loadingPageService.getList("aboutUs"),
			loadingPageService.getList("leadership"),
		]).then((res) => {
			if (res[0]?.status === 200) {
				let response = res[0].data?.data;
				if (!!response?.length) {
					information["header"] = response;
				}
			}
			if (res[1]?.status === 200) {
				let response = res[1].data?.data;
				if (!!response?.length) {
					information["clients"] = response;
				}
			}
			if (res[2]?.status === 200) {
				let response = res[2].data?.data;
				if (!!response?.length) {
					information["about_us"] = response;
				}
			}
			if (res[3]?.status === 200) {
				let response = res[3].data?.data?.data;
				if (!!response?.length) {
					information["leadership"] = response;
				}
			}
			setData({ ...information });
		});
	}, []);

	return (
		<div className={`landing-page ${lang}`}>
			<Header data={data?.header} />
			<AboutUs data={data?.about_us} />
			<Leadership data={data?.leadership} />
			<Clients data={data?.clients || []} />
			<Static data={data?.about_us || []} />
			<Footer />
		</div>
	);
};
export default LandingPage;
